import { enableMapSet } from "immer";
import { AxiosError } from "axios";
import type { NavigateFunction } from "react-router";
import { baseHttpClient } from "@mobile/api/http-client";
// theme store를 import하여 시스템 다크모드 감지 + classList 동기화 코드를 실행
import "@mobile/features/theme/store";
import { initSentry } from "@mobile/lib/sentry";
import { startVisualViewportTracking } from "@repo/share-log-ui/lib/visual-viewport";
import { startKeyboardFocusTracking } from "@repo/share-log-ui/lib/keyboard-focus";

export const preRenderSetup = () => {
  initSentry();
  enableMapSet();
  startVisualViewportTracking();
  startKeyboardFocusTracking();
};

interface PostRenderSetupOptions {
  navigate: NavigateFunction;
}

export const postRenderSetup = ({ navigate }: PostRenderSetupOptions) => {
  const interceptorId = baseHttpClient.addErrorResponseInterceptor(
    async (error) => {
      if (error instanceof AxiosError) {
        if (error.response?.status === 401) {
          await navigate("/login");
        }
      }
    },
  );

  return () => {
    baseHttpClient.removeErrorResponseInterceptor(interceptorId);
  };
};
